import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { CommentFooter } from './components/CommentFooter';
import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC = () => {
	const {
		data: { comment },
	} = usePageBody();

	return (
		<div>
			<div className="border-stroke-weak before:border-t-stroke-weak relative mb-4 rounded-lg border p-2 before:absolute before:bottom-[-9px] before:left-[10px] before:border-t-[9px] before:border-r-[7px] before:border-b-0 before:border-l-[7px] before:border-r-transparent before:border-l-transparent before:content-[''] after:absolute after:bottom-[-7px] after:left-[10px] after:border-t-[9px] after:border-r-[7px] after:border-b-0 after:border-l-[7px] after:border-t-white after:border-r-transparent after:border-l-transparent after:content-['']">
				<Text
					as="div"
					variant="body"
					size="medium"
					className="wrap-break-word whitespace-pre-wrap md:text-lg"
					data-qa="comment-body"
				>
					{comment}
				</Text>
			</div>
			<CommentFooter />
		</div>
	);
};
